import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import SvgIcons from "../../../Icons/SvgIcons";
import {setWizardCloneLogic} from "../../wizardActions";
import {AccessRights} from "../../../../schemas/accessRightsModel";

const WIZARD_CLONE_STEPS = [
  "savingWizard",
  "receivingExistingWizards",
  "receivingFabricatorFeatureGroups",
  "creatingMissingFeatureGroups",
  "updatingWizardFeatures",
  "receivingFeaturesToClone",
  "cloningFeatures",
  "finished"
]
const WizardClonePopupContentWhenCloning = (props) => {

  const {wizardCloneLogic, setWizardCloneLogic, fabricators} = props;
  const {wizardName, cloneStep, toFabricator, cloneGroupName} = wizardCloneLogic;

  useEffect(() => {
    return () => {
      setWizardCloneLogic({
        visible: false,
        toFabricator: 0,
        cloneStep: 0,
        wizardName: "",
        finished: false
      })
    }
  }, []);

  const currentFab = toFabricator ? fabricators.find(fab => {
    return fab.customerBaseId === toFabricator || fab.id === toFabricator
  }) : null;

  return (
    <div className="wizard-popup">
      <div className="fabricators-popup-search">
        <h2 className="ui-title--gray">
          <FormattedMessage id="wizard.cloning.title"/>
          {wizardName ? " " + wizardName : null}
          {currentFab ? " to fabricator: " + (currentFab.companyName || currentFab.name) : null}
        </h2>
      </div>
      <div className="fabricators-popup-content">
        <ul className="ui-list">
          {WIZARD_CLONE_STEPS.map((step, stepIndex) => {
            const finished = stepIndex < cloneStep;
            const current = stepIndex === cloneStep;
            return (
              <li key={step}
                  className={(finished ? " sales-person-list__item--finished" : "")
                    + (stepIndex === cloneStep ? " sales-person-list__item--current" : "")}>
                <div className="table-cell">
                  <div className="fabricators-popup-row">
                    <div className="fabricators-popup-col">
                      <FormattedMessage id={"wizard.cloning." + step}/>
                      {step === "updatingWizardFeatures" && cloneGroupName ? "... "+cloneGroupName : ""}
                    </div>
                  </div>
                </div>
                <div className="table-cell">
                  <div className="fabricators-popup-row">
                    <div className="fabricators-popup-col">
                      {finished ? SvgIcons.checkIcon : null}
                      {current ? <div style={{marginLeft: "-5px"}} className="ui-loader ui-loader--small"/> : null}
                    </div>
                  </div>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {fabricators} = store;
  const AR = AccessRights.get(store);
  const isSiteAdmin = AR.isSiteAdmin(true);
  const {enabledEntities} = store.customers;
  const {wizardCloneLogic} = store.wizardState;

  return {
    fabricators: isSiteAdmin ? enabledEntities.data.rows.filter(row => {
      return row.dashboardEntity === "MasterFabricator" || row.dashboardEntity === "SiteAdmin"
    }) : fabricators.data.rows,
    wizardCloneLogic,
  };
};

const mapDispatchToProps = {
  setWizardCloneLogic
}

export default connect(mapStateToProps, mapDispatchToProps)(WizardClonePopupContentWhenCloning)
